import * as React from 'react'
import styled from 'styled-components'
import { styledComponentWithProps } from '../../../Styled/Shared'

const ArrowRight = require('../../../Shared/arrow_right.svg')
const ArrowDown = require('../../../Shared/arrow_down.svg')

export const Trigger = styled.h6`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  height: 30px;
  line-height: 30px;

  button {
    color: ${({ theme }) => theme.colors.light};
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    font-size: ${({ theme }) => theme.fonts.defaultSize};
    border: 0;
    padding: 0;
    background: inherit;
  }

  button.main {
    flex: 1;
    text-align: left;
    padding: 0 20px 0;
    background: no-repeat left center / 10px 10px url(${ArrowRight});

    &.open {
      background: no-repeat left center / 10px 10px url(${ArrowDown});
    }
  }

  .hover-extra {
    display: none;
  }

  &:hover {
    background: #eef1f2;

    .hover-extra {
      display: flex;
    }
  }
`

type ToggleViewProps = {
  secondary?: boolean
}

const ToggleViewWrapper = styledComponentWithProps<ToggleViewProps>(styled.div)`
  margin-top: ${({ secondary }) => (secondary ? '0px' : '15px')};
  padding-top: ${({ secondary }) => (secondary ? '0px' : '20px')};

  margin-left: ${({ secondary }) => (secondary ? '10px' : '0')};

  &:not(:first-of-type) {
    border-top: ${({ secondary }) => (secondary ? '0' : '2px solid #dbdfe0')};
  }
`

type Props = {
  title: string
  open?: boolean // if specified, this will become a controlled component
  onClick?: () => void
  extra?: React.ReactNode
  secondary?: boolean
}

/* TODO: pretty animation */
class ToggleView extends React.Component<Props, { open: boolean }> {
  constructor(props: Props) {
    super(props)
    this.state = { open: true }
  }

  toggle = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    const isOpen =
      this.props.open !== undefined ? this.props.open : this.state.open
    return (
      <ToggleViewWrapper secondary={this.props.secondary}>
        <Trigger onClick={this.props.onClick || this.toggle}>
          <button type="button" className={isOpen ? 'main open' : 'main'}>
            {this.props.title}
          </button>
          <div className="hover-extra">{this.props.extra}</div>
        </Trigger>
        {isOpen && this.props.children}
      </ToggleViewWrapper>
    )
  }
}

export default ToggleView



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/ToggleView/index.tsx